// extracted by css-extract-rspack-plugin
export default {"root":"root-Dhn8Hs","title":"title-fkIoy5"};